(() => {
    if (customElements.get('stride-enterprise-header')) return;

    class StrideEnterpriseHeader extends HTMLElement {
      connectedCallback() {
        this.breakpoint = Number(this.dataset.breakpoint || 990);
        this.scrollThreshold = Number(this.dataset.scrollThreshold || 24);
        this.transparentStart = this.dataset.transparentStart === 'true';

        this.mobileToggle = this.querySelector('[data-mobile-toggle]');
        this.desktopMenuToggle = this.querySelector('[data-desktop-menu-toggle]');
        this.desktopMenuOverlay = this.querySelector('[data-desktop-menu-overlay]');
        this.mobileDrawer = this.querySelector('[data-mobile-drawer]');
        this.mobileViewport = this.querySelector('[data-mobile-viewport]');
        this.mobileServicesScrollCue = this.querySelector('[data-mobile-services-scroll-cue]');
        this.backdrop = this.querySelector('[data-close-mega]');
        this.megaTriggers = Array.from(
          this.querySelectorAll('[data-mega-trigger]')
        );
        this.megaPanels = Array.from(
          this.querySelectorAll('[data-mega-panel]')
        );
        this.hoverCloseDelay = 240;

        this.handleClick = this.handleClick.bind(this);
        this.handleDocumentClick = this.handleDocumentClick.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.handleResize = this.handleResize.bind(this);
        this.handleMobileViewportScroll = this.handleMobileViewportScroll.bind(this);
        this.handleMegaTriggerEnter =
          this.handleMegaTriggerEnter.bind(this);
        this.handleMegaTriggerLeave =
          this.handleMegaTriggerLeave.bind(this);
        this.handleMegaPanelEnter =
          this.handleMegaPanelEnter.bind(this);
        this.handleMegaPanelLeave =
          this.handleMegaPanelLeave.bind(this);

        this.addEventListener('click', this.handleClick);
        document.addEventListener('click', this.handleDocumentClick);
        document.addEventListener('keydown', this.handleKeydown);
        window.addEventListener('scroll', this.handleScroll, {
          passive: true
        });
        window.addEventListener('resize', this.handleResize, {
          passive: true
        });

        if (this.mobileViewport) {
          this.mobileViewport.addEventListener(
            'scroll',
            this.handleMobileViewportScroll,
            { passive: true }
          );
        }

        this.megaTriggers.forEach((trigger) => {
          trigger.addEventListener(
            'pointerenter',
            this.handleMegaTriggerEnter
          );
          trigger.addEventListener(
            'pointerleave',
            this.handleMegaTriggerLeave
          );
        });

        this.megaPanels.forEach((panel) => {
          panel.addEventListener(
            'pointerenter',
            this.handleMegaPanelEnter
          );
          panel.addEventListener(
            'pointerleave',
            this.handleMegaPanelLeave
          );
        });

        this.updateScrolledState();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
        document.removeEventListener('click', this.handleDocumentClick);
        document.removeEventListener('keydown', this.handleKeydown);
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleResize);

        if (this.mobileViewport) {
          this.mobileViewport.removeEventListener(
            'scroll',
            this.handleMobileViewportScroll
          );
        }

        window.clearTimeout(this.megaHoverOpenTimer);
        window.clearTimeout(this.megaHoverCloseTimer);

        this.megaTriggers.forEach((trigger) => {
          trigger.removeEventListener(
            'pointerenter',
            this.handleMegaTriggerEnter
          );
          trigger.removeEventListener(
            'pointerleave',
            this.handleMegaTriggerLeave
          );
        });

        this.megaPanels.forEach((panel) => {
          panel.removeEventListener(
            'pointerenter',
            this.handleMegaPanelEnter
          );
          panel.removeEventListener(
            'pointerleave',
            this.handleMegaPanelLeave
          );
        });

        document.documentElement.classList.remove(
          'stride-header-menu-open'
        );
      }

      handleClick(event) {
        const contactTrigger =
          event.target.closest(
            '[data-stride-contact-open]'
          );

        if (
          contactTrigger &&
          this.contains(contactTrigger)
        ) {
          this.closeMegaMenu(false);

          if (
            this.classList.contains(
              'is-desktop-drawer-open'
            )
          ) {
            this.closeDesktopMenu(false, true);
          }

          if (
            this.classList.contains(
              'is-mobile-open'
            )
          ) {
            this.closeMobileMenu(
              false,
              true
            );
          }

          /*
            Vi stoppar INTE eventet här.

            Kontakt-drawern lyssnar globalt på
            [data-stride-contact-open] och öppnar
            sig själv när klicket når document.
          */

          return;
        }

        const megaTrigger =
          event.target.closest(
            '[data-mega-trigger]'
          );

        if (
          megaTrigger &&
          this.contains(megaTrigger)
        ) {
          event.preventDefault();

          this.toggleMegaMenu(
            megaTrigger
          );

          return;
        }

        const closeMega =
          event.target.closest(
            '[data-close-mega]'
          );

        if (
          closeMega &&
          this.contains(closeMega)
        ) {
          this.closeMegaMenu();

          return;
        }

        const desktopMenuToggle =
          event.target.closest(
            '[data-desktop-menu-toggle]'
          );

        if (
          desktopMenuToggle &&
          this.contains(desktopMenuToggle)
        ) {
          event.preventDefault();
          this.toggleDesktopMenu();
          return;
        }

        const desktopMenuClose =
          event.target.closest(
            '[data-desktop-menu-close]'
          );

        if (
          desktopMenuClose &&
          this.contains(desktopMenuClose)
        ) {
          event.preventDefault();
          this.closeDesktopMenu();
          return;
        }

        const mobileToggle =
          event.target.closest(
            '[data-mobile-toggle]'
          );

        if (
          mobileToggle &&
          this.contains(mobileToggle)
        ) {
          event.preventDefault();

          this.toggleMobileMenu();

          return;
        }

        const mobileTab =
          event.target.closest(
            '[data-mobile-tab]'
          );

        if (
          mobileTab &&
          this.contains(mobileTab)
        ) {
          event.preventDefault();

          this.setMobileTab(
            mobileTab.dataset.mobileTab
          );

          return;
        }

        const servicesScrollCue =
          event.target.closest(
            '[data-mobile-services-scroll-cue]'
          );

        if (
          servicesScrollCue &&
          this.contains(servicesScrollCue)
        ) {
          event.preventDefault();

          if (this.mobileViewport) {
            this.mobileViewport.scrollBy({
              top: Math.max(
                180,
                this.mobileViewport.clientHeight * 0.55
              ),
              behavior: 'smooth'
            });
          }

          return;
        }

        const mobileOpen =
          event.target.closest(
            '[data-mobile-open]'
          );

        if (
          mobileOpen &&
          this.contains(mobileOpen)
        ) {
          event.preventDefault();

          this.showMobilePanel(
            mobileOpen.dataset.mobileOpen
          );

          return;
        }

        const mobileBack =
          event.target.closest(
            '[data-mobile-back]'
          );

        if (
          mobileBack &&
          this.contains(mobileBack)
        ) {
          event.preventDefault();

          this.showMobilePanel('root');

          return;
        }

        const menuLink =
          event.target.closest('a');

        if (
          menuLink &&
          this.contains(menuLink)
        ) {
          if (
            menuLink.closest(
              '[data-mega-panel]'
            )
          ) {
            this.closeMegaMenu(false);
          }

          if (
            menuLink.closest(
              '[data-mobile-drawer]'
            )
          ) {
            if (this.classList.contains('is-desktop-drawer-open')) {
              this.closeDesktopMenu(false);
            } else {
              this.closeMobileMenu(false);
            }
          }
        }
      }

      supportsDesktopHover() {
        return (
          window.innerWidth >
            this.breakpoint &&
          window.matchMedia(
            '(hover: hover) and (pointer: fine)'
          ).matches
        );
      }

      handleMegaTriggerEnter(event) {
        if (!this.supportsDesktopHover()) {
          return;
        }

        const trigger = event.currentTarget;

        window.clearTimeout(
          this.megaHoverCloseTimer
        );
        window.clearTimeout(
          this.megaHoverOpenTimer
        );

        this.openMegaMenu(trigger);
      }

      handleMegaTriggerLeave() {
        if (!this.supportsDesktopHover()) {
          return;
        }

        window.clearTimeout(
          this.megaHoverOpenTimer
        );

        this.scheduleMegaClose();
      }

      handleMegaPanelEnter() {
        if (!this.supportsDesktopHover()) {
          return;
        }

        window.clearTimeout(
          this.megaHoverCloseTimer
        );
      }

      handleMegaPanelLeave() {
        if (!this.supportsDesktopHover()) {
          return;
        }

        this.scheduleMegaClose();
      }

      scheduleMegaClose() {
        window.clearTimeout(
          this.megaHoverCloseTimer
        );

        this.megaHoverCloseTimer =
          window.setTimeout(() => {
            this.closeMegaMenu(false);
          }, this.hoverCloseDelay);
      }

      handleDocumentClick(event) {
        if (
          !this.contains(event.target) &&
          this.classList.contains(
            'is-mega-open'
          )
        ) {
          this.closeMegaMenu();
        }
      }

      handleKeydown(event) {
        if (event.key !== 'Escape') {
          return;
        }

        if (
          this.classList.contains(
            'is-desktop-drawer-open'
          )
        ) {
          this.closeDesktopMenu();
          return;
        }

        if (
          this.classList.contains(
            'is-mobile-open'
          )
        ) {
          this.closeMobileMenu();

          return;
        }

        if (
          this.classList.contains(
            'is-mega-open'
          )
        ) {
          this.closeMegaMenu();
        }
      }

      handleScroll() {
        this.updateScrolledState();
      }

      handleMobileViewportScroll() {
        this.updateServicesScrollCue();
      }

      updateServicesScrollCue() {
        if (
          !this.mobileViewport ||
          !this.mobileServicesScrollCue ||
          !this.mobileDrawer ||
          this.mobileDrawer.hidden
        ) {
          return;
        }

        const servicesPanel = this.mobileDrawer.querySelector(
          '[data-mobile-tab-panel="services"]'
        );

        const servicesIsActive =
          servicesPanel &&
          !servicesPanel.hidden &&
          servicesPanel.classList.contains('is-active');

        const remainingScroll =
          this.mobileViewport.scrollHeight -
          this.mobileViewport.clientHeight -
          this.mobileViewport.scrollTop;

        const hasMoreContent =
          remainingScroll > 28;

        this.mobileServicesScrollCue.hidden =
          !servicesIsActive ||
          !hasMoreContent;
      }

      handleResize() {
        this.updateServicesScrollCue();

        if (
          window.innerWidth <= this.breakpoint &&
          this.classList.contains('is-desktop-drawer-open')
        ) {
          this.closeDesktopMenu(false, true);
        }

        if (
          window.innerWidth >
          this.breakpoint
        ) {
          if (
            this.classList.contains(
              'is-mobile-open'
            )
          ) {
            this.closeMobileMenu(
              false,
              true
            );
          }
        } else if (
          this.classList.contains(
            'is-mega-open'
          )
        ) {
          this.closeMegaMenu(false);
        }
      }

      updateScrolledState() {
        const shouldBeSolid =
          !this.transparentStart ||
          window.scrollY >
            this.scrollThreshold;

        this.classList.toggle(
          'is-scrolled',
          shouldBeSolid
        );
      }

      openMegaMenu(trigger) {
        const panelId =
          trigger.dataset.megaTrigger;

        const panel =
          document.getElementById(
            panelId
          );

        if (
          !panel ||
          !this.contains(panel)
        ) {
          return;
        }

        window.clearTimeout(
          this.megaHoverOpenTimer
        );
        window.clearTimeout(
          this.megaHoverCloseTimer
        );

        const isAlreadyOpen =
          trigger.getAttribute(
            'aria-expanded'
          ) === 'true';

        if (isAlreadyOpen) {
          return;
        }

        this.closeMegaMenu(false);

        trigger.setAttribute(
          'aria-expanded',
          'true'
        );

        panel.hidden = false;

        this.classList.add(
          'is-mega-open'
        );

        if (this.backdrop) {
          this.backdrop.hidden = false;
        }
      }

      toggleMegaMenu(trigger) {
        const wasOpen =
          trigger.getAttribute(
            'aria-expanded'
          ) === 'true';

        if (wasOpen) {
          this.closeMegaMenu(false);
          return;
        }

        this.openMegaMenu(trigger);
      }

      closeMegaMenu(
        restoreFocus = true
      ) {
        window.clearTimeout(
          this.megaHoverOpenTimer
        );
        window.clearTimeout(
          this.megaHoverCloseTimer
        );

        const openTrigger =
          this.querySelector(
            '[data-mega-trigger][aria-expanded="true"]'
          );

        this.querySelectorAll(
          '[data-mega-trigger]'
        ).forEach((trigger) => {
          trigger.setAttribute(
            'aria-expanded',
            'false'
          );
        });

        this.querySelectorAll(
          '[data-mega-panel]'
        ).forEach((panel) => {
          panel.hidden = true;
        });

        this.classList.remove(
          'is-mega-open'
        );

        if (this.backdrop) {
          this.backdrop.hidden = true;
        }

        if (
          restoreFocus &&
          openTrigger
        ) {
          openTrigger.focus();
        }
      }

      toggleDesktopMenu() {
        if (this.classList.contains('is-desktop-drawer-open')) {
          this.closeDesktopMenu();
        } else {
          this.openDesktopMenu();
        }
      }

      openDesktopMenu() {
        if (
          window.innerWidth <= this.breakpoint ||
          !this.mobileDrawer ||
          !this.desktopMenuToggle
        ) {
          return;
        }

        this.closeMegaMenu(false);

        if (window.StrideContactDrawer?.close) {
          window.StrideContactDrawer.close();
        }

        this.showMobilePanel('root');
        this.setMobileTab('retainers', false);

        this.mobileDrawer.hidden = false;
        this.mobileDrawer.setAttribute('aria-hidden', 'false');

        if (this.desktopMenuOverlay) {
          this.desktopMenuOverlay.hidden = false;
        }

        this.desktopMenuToggle.setAttribute('aria-expanded', 'true');
        this.desktopMenuToggle.setAttribute('aria-label', 'Stäng meny');

        this.classList.add('is-desktop-drawer-open');
        document.documentElement.classList.add('stride-header-menu-open');

        requestAnimationFrame(() => {
          this.updateServicesScrollCue();
        });
      }

      closeDesktopMenu(
        restoreFocus = true,
        immediate = false
      ) {
        if (
          !this.mobileDrawer ||
          !this.desktopMenuToggle
        ) {
          return;
        }

        this.classList.remove('is-desktop-drawer-open');
        this.mobileDrawer.setAttribute('aria-hidden', 'true');
        this.desktopMenuToggle.setAttribute('aria-expanded', 'false');
        this.desktopMenuToggle.setAttribute('aria-label', 'Öppna meny');
        document.documentElement.classList.remove('stride-header-menu-open');

        if (this.mobileServicesScrollCue) {
          this.mobileServicesScrollCue.hidden = true;
        }

        const finishClose = () => {
          if (!this.classList.contains('is-desktop-drawer-open')) {
            this.mobileDrawer.hidden = true;

            if (this.desktopMenuOverlay) {
              this.desktopMenuOverlay.hidden = true;
            }

            this.showMobilePanel('root');
          }
        };

        if (immediate) {
          finishClose();
        } else {
          window.setTimeout(finishClose, 230);
        }

        if (restoreFocus) {
          this.desktopMenuToggle.focus({ preventScroll: true });
        }
      }

      toggleMobileMenu() {
        if (
          this.classList.contains(
            'is-mobile-open'
          )
        ) {
          this.closeMobileMenu();
        } else {
          this.openMobileMenu();
        }
      }

      openMobileMenu() {
        if (
          !this.mobileDrawer ||
          !this.mobileToggle
        ) {
          return;
        }

        this.closeMegaMenu(false);

        window.clearTimeout(
          this.mobileCloseTimer
        );

        this.showMobilePanel('root');
        this.setMobileTab('retainers', false);

        this.mobileDrawer.hidden = false;

        this.mobileDrawer.setAttribute(
          'aria-hidden',
          'false'
        );

        requestAnimationFrame(() => {
          this.updateServicesScrollCue();
        });

        this.mobileToggle.setAttribute(
          'aria-expanded',
          'true'
        );

        this.mobileToggle.setAttribute(
          'aria-label',
          'Stäng meny'
        );

        document.documentElement.classList.add(
          'stride-header-menu-open'
        );

        requestAnimationFrame(() => {
          this.classList.add(
            'is-mobile-open'
          );

          const firstControl =
            this.mobileDrawer.querySelector(
              '[data-mobile-panel="root"] [data-mobile-tab]'
            );

          if (firstControl) {
            firstControl.focus({
              preventScroll: true
            });
          }
        });
      }

      closeMobileMenu(
        restoreFocus = true,
        immediate = false
      ) {
        if (
          !this.mobileDrawer ||
          !this.mobileToggle
        ) {
          return;
        }

        this.classList.remove(
          'is-mobile-open'
        );

        this.mobileDrawer.setAttribute(
          'aria-hidden',
          'true'
        );

        if (this.mobileServicesScrollCue) {
          this.mobileServicesScrollCue.hidden = true;
        }

        this.mobileToggle.setAttribute(
          'aria-expanded',
          'false'
        );

        this.mobileToggle.setAttribute(
          'aria-label',
          'Öppna meny'
        );

        document.documentElement.classList.remove(
          'stride-header-menu-open'
        );

        window.clearTimeout(
          this.mobileCloseTimer
        );

        const finishClose = () => {
          if (
            !this.classList.contains(
              'is-mobile-open'
            )
          ) {
            this.mobileDrawer.hidden =
              true;

            this.showMobilePanel(
              'root'
            );
          }
        };

        if (immediate) {
          finishClose();
        } else {
          this.mobileCloseTimer =
            window.setTimeout(
              finishClose,
              230
            );
        }

        if (restoreFocus) {
          this.mobileToggle.focus({
            preventScroll: true
          });
        }
      }

      setMobileTab(
        tabName,
        resetScroll = true
      ) {
        if (!this.mobileDrawer) {
          return;
        }

        const tabs = Array.from(
          this.mobileDrawer.querySelectorAll(
            '[data-mobile-tab]'
          )
        );

        const panels = Array.from(
          this.mobileDrawer.querySelectorAll(
            '[data-mobile-tab-panel]'
          )
        );

        tabs.forEach((tab) => {
          const active =
            tab.dataset.mobileTab ===
            tabName;

          tab.classList.toggle(
            'is-active',
            active
          );

          tab.setAttribute(
            'aria-selected',
            active ? 'true' : 'false'
          );
        });

        panels.forEach((panel) => {
          const active =
            panel.dataset.mobileTabPanel ===
            tabName;

          panel.classList.toggle(
            'is-active',
            active
          );

          panel.hidden = !active;
        });

        if (
          resetScroll &&
          this.mobileViewport
        ) {
          this.mobileViewport.scrollTop =
            0;
        }

        requestAnimationFrame(() => {
          this.updateServicesScrollCue();
        });
      }

      showMobilePanel(panelName) {
        if (!this.mobileDrawer) {
          return;
        }

        this.mobileDrawer
          .querySelectorAll(
            '[data-mobile-panel]'
          )
          .forEach((panel) => {
            panel.hidden =
              panel.dataset.mobilePanel !==
              panelName;
          });

        if (this.mobileViewport) {
          this.mobileViewport.scrollTop =
            0;
        }

        if (panelName !== 'root') {
          requestAnimationFrame(() => {
            const backButton =
              this.mobileDrawer.querySelector(
                `[data-mobile-panel="${panelName}"] [data-mobile-back]`
              );

            if (backButton) {
              backButton.focus({
                preventScroll: true
              });
            }
          });
        }
      }
    }

    customElements.define(
      'stride-enterprise-header',
      StrideEnterpriseHeader
    );
  })();